<template>
    <fragment>
        <!-- <div class="absolute"></div> -->
        <intro-panel
            :isOpen="(!selectedStep && !hasClearedIntro) || selectedStep === 'review' || selectedStep === 'group'" element-height="370px"
            class="absolute left-0 right-0 bottom-0"
            @clear-intro="clearIntro" :class="hasClearedIntro && 'opacity-0'" />
        <menu-panel  :isOpen="!selectedStep && hasClearedIntro" element-height="250px" />
        <transition name="cz2__fade" @after-enter="afterEnterTransition">
            <color-panels v-if="selectedStep?.startsWith('colors')" :isOpen="selectedStep?.startsWith('colors')"  element-height="250px" />
        </transition>
        <transition name="cz2__fade" @after-enter="afterEnterTransition">
            <graphics-panel  v-if="selectedStep === 'images'"  :isOpen="selectedStep === 'images'" element-height="250px" />
        </transition>
        <transition name="cz2__fade" @after-enter="afterEnterTransition">
            <text-panel v-if="selectedStep === 'text'" :isOpen="selectedStep === 'text'" element-height="250px" />
        </transition>
        <transition name="cz2__fade" @after-enter="afterEnterTransition">
            <monogram-panel v-if="selectedStep === 'monogram'" :isOpen="selectedStep === 'monogram'" element-height="250px" />
        </transition>
        <transition name="cz2__fade" @after-enter="afterEnterTransition">
            <div class="absolute top-0 left-0 right-0 bottom-0 min-h-screen" v-if="selectedStep === 'review'">
                <review-order-panel :isOpen="selectedStep === 'review'" />
            </div>
        </transition>
        <transition name="cz2__fade" @after-enter="afterEnterTransition">
            <div class="absolute top-0 left-0 right-0 bottom-0 min-h-screen" v-if="selectedStep === 'group'">
                <group-ordering-panel :isOpen="selectedStep === 'group'" />
            </div>
        </transition>
    </fragment>
</template>

<script>
    import { Fragment } from 'vue-frag';
    import { mapState } from 'vuex';
    import IntroPanel from './IntroPanel.vue';
    import MenuPanel from './MenuPanel.vue';
    import GraphicsPanel from './GraphicsPanel.vue';
    import MobilePanelWrapper from './MobilePanelWrapper.vue';
    import TextPanel from './TextPanel.vue';
    import ColorPanels from './ColorPanels.vue';
    import MonogramPanel from './MonogramPanel.vue';
    import ReviewOrderPanel from '../ReviewOrderPanel.vue';
    import FullScreenPanel from '../FullScreenPanel.vue';
    import FullScreenPanelContent from '../FullScreenPanelContent.vue';
    import GroupOrderingPanel from '../GroupOrderingPanel.vue';

    import * as Tours from '../../../tours';

    export default {
        components: {
            MobilePanelWrapper,
            IntroPanel,
            MenuPanel,
            GraphicsPanel,
            TextPanel,
            Fragment,
            ColorPanels,
            MonogramPanel,
            ReviewOrderPanel,
            FullScreenPanel,
            FullScreenPanelContent,
            GroupOrderingPanel,
        },
        data() {
            return {
                currentPanel: 'intro',
                hasClearedIntro: false,
            };
        },
        computed: {
            ...mapState(['selectedStep']),
        },
        watch: {
            hasClearedIntro() {
                if (this.hasClearedIntro === true) {
                    setTimeout(() => {
                        this.$store.dispatch('setCurrentTour', Tours.introSmall());
                    }, 250);
                }
            },
        },
        methods: {
            clearIntro() {
                this.hasClearedIntro = true;
            },
            afterEnterTransition() {
                this.$store.dispatch('globalEvent', {
                    event: 'secondaryEntered',
                });
            },
        },
    };
</script>
